// Vars
var $selectRepository = $('#selectRepository');
var $selectPeriod = $('#selectPeriod');
var $selectPeriodMultiple = $('#selectPeriodMultiple');
var $selectShowBy = $('#selectShowBy');
var $selectShowByMultiple = $('#selectShowByMultiple');
var $buttonFetchData = $('#buttonFetchData');
var $buttonFetchMultipleData = $('#buttonFetchMultipleData');
var $fetchDataLoader = $('#fetchDataLoader');
var $chartContainer = $('#chartContainer');
var $tableContainer = $('#tableContainer');
var $inputDatepicker = $('#inputDatepicker');
var $containerDate = $('#containerDate');
var $statsContainer = $('#statsContainer');

// Api config
var endpointBaseUrl = 'https://api.github.com/repos/';
var repository = $selectRepository.val();
var params = '/stats/commit_activity';
var endpointUrl = `${endpointBaseUrl}${repository}${params}`;

// Raw data from endpoint
var fetchData = {
  daily: [],
  weekly: [],
  monthly: [],
};

var tableData = {
  daily: [],
  weekly: [],
  monthly: [],
};

var tableDataMultiple = {
  'last-week': [],
  'last-month': [],
  'last-year': [],
};

// Chart config
var chartData = [];
var chartConfigs = {
  type: 'line',
  width: '100%',
  height: '400',
  dataFormat: 'json',
  dataSource: {
    chart: {
      caption: 'Commit Activity',
      subCaption: 'Selected Repo',
      xAxisName: 'Week',
      yAxisName: 'Total commits',
      theme: 'fusion',
    },
    data: chartData,
    trendlines: [
      {
        line: [
          {
            startvalue: '1',
            color: '#1aaf5d',
            displayvalue: 'Average',
            thickness: '2',
          },
        ],
      },
    ],
  },
};

var chartConfigsMultiple = {
  type: 'msline',
  width: '100%',
  height: '400',
  dataFormat: 'json',
  dataSource: {
    chart: {
      caption: 'Commit activity',
      yaxisname: 'Number of commits',
      theme: 'fusion',
    },
    categories: [
      {
        category: [
          {
            label: '2012',
          },
          {
            label: '2013',
          },
          {
            label: '2014',
          },
          {
            label: '2015',
          },
          {
            label: '2016',
          },
        ],
      },
    ],
    dataset: [
      {
        seriesname: 'Facebook',
        data: [
          {
            value: '62',
          },
          {
            value: '64',
          },
          {
            value: '64',
          },
          {
            value: '66',
          },
          {
            value: '78',
          },
        ],
      },
      {
        seriesname: 'Instagram',
        data: [
          {
            value: '16',
          },
          {
            value: '28',
          },
          {
            value: '34',
          },
          {
            value: '42',
          },
          {
            value: '54',
          },
        ],
      },
      {
        seriesname: 'LinkedIn',
        data: [
          {
            value: '20',
          },
          {
            value: '22',
          },
          {
            value: '27',
          },
          {
            value: '22',
          },
          {
            value: '29',
          },
        ],
      },
      {
        seriesname: 'Twitter',
        data: [
          {
            value: '18',
          },
          {
            value: '19',
          },
          {
            value: '21',
          },
          {
            value: '21',
          },
          {
            value: '24',
          },
        ],
      },
    ],
  },
};

// Period & Mode config
var currentPeriod = 'last-month';
var currentMode = 'daily';
var selectedDate = dayjs(Date.now()).toISOString();

var datepickerConfig = {
  onSelect: handleInputDatepickerSelect,
  language: 'en',
  autoClose: true,
};

// Other configs
var percentage = 70;

var reposList = [
  {
    slug: 'aeternity/aeternity',
    url: 'https://github.com/aeternity/aeternity',
  },
  {
    slug: 'bitcoincashorg/bitcoincash.org',
    url: 'https://github.com/bitcoincashorg/bitcoincash.org',
  },
  {
    slug: 'ethereum/go-ethereum',
    url: 'https://github.com/ethereum/go-ethereum',
  },
  {
    slug: 'ethereumclassic/ECIPs',
    url: 'https://github.com/ethereumclassic/ECIPs',
  },
  {
    slug: 'ethereumclassic/ethereumclassic.github.io',
    url: 'https://github.com/ethereumclassic/ethereumclassic.github.io',
  },
  {
    slug: 'bitcoin/bitcoin',
    url: 'https://github.com/bitcoin/bitcoin',
  },
  {
    slug: 'EOSIO/eos',
    url: 'https://github.com/EOSIO/eos',
  },
  {
    slug: 'litecoin-project/litecoin',
    url: 'https://github.com/litecoin-project/litecoin',
  },
  {
    slug: 'ripple/rippled',
    url: 'https://github.com/ripple/rippled',
  },
  {
    slug: 'ripple/ripple-lib',
    url: 'https://github.com/ripple/ripple-lib',
  },
  {
    slug: 'bitcoin-sv/bitcoin-sv',
    url: 'https://github.com/bitcoin-sv/bitcoin-sv',
  },
  {
    slug: 'binance-exchange/binance-java-api',
    url: 'https://github.com/binance-exchange/binance-java-api',
  },
  {
    slug: 'binance-exchange/node-binance-api',
    url: 'https://github.com/binance-exchange/node-binance-api',
  },
  {
    slug: 'stellar/stellar-protocol',
    url: 'https://github.com/stellar/stellar-protocol',
  },
  {
    slug: 'stellar/stellar-core',
    url: 'https://github.com/stellar/stellar-core',
  },
  {
    slug: 'monero-project/monero',
    url: 'https://github.com/monero-project/monero',
  },
  {
    slug: 'smartcontractkit/chainlink',
    url: 'https://github.com/smartcontractkit/chainlink',
  },
  {
    slug: 'input-output-hk/cardano-sl',
    url: 'https://github.com/input-output-hk/cardano-sl',
  },
  {
    slug: 'tronprotocol/java-tron',
    url: 'https://github.com/tronprotocol/java-tron',
  },
  {
    slug: 'crypto-com/jellyfish-merkle-tree',
    url: 'https://github.com/crypto-com/jellyfish-merkle-tree',
  },
  {
    slug: 'crypto-com/token-profile',
    url: 'https://github.com/crypto-com/token-profile',
  },
  {
    slug: 'crypto-comdashpay/dash',
    url: 'https://github.com/crypto-comdashpay/dash',
  },
  {
    slug: 'centrehq/centre-tokens',
    url: 'https://github.com/centrehq/centre-tokens',
  },
  {
    slug: 'neo-project/neo',
    url: 'https://github.com/neo-project/neo',
  },
  {
    slug: 'rublixdev/hedgtokenmint',
    url: 'https://github.com/rublixdev/hedgtokenmint',
  },
  {
    slug: 'iotaledger/iri',
    url: 'https://github.com/iotaledger/iri',
  },
  {
    slug: 'cosmos/cosmos-sdk',
    url: 'https://github.com/cosmos/cosmos-sdk',
  },
  {
    slug: 'zcash/zcash',
    url: 'https://github.com/zcash/zcash',
  },
  {
    slug: 'nemtech/symbol-sdk-typescript-javascript',
    url: 'https://github.com/nemtech/symbol-sdk-typescript-javascript',
  },
  {
    slug: 'ontio/ontology',
    url: 'https://github.com/ontio/ontology',
  },
  {
    slug: 'ftexchange/ftx',
    url: 'https://github.com/ftexchange/ftx',
  },
  {
    slug: 'dogecoin/dogecoin',
    url: 'https://github.com/dogecoin/dogecoin',
  },
  {
    slug: 'paxosglobal/pax-contracts',
    url: 'https://github.com/paxosglobal/pax-contracts',
  },
  {
    slug: 'vechain/thor',
    url: 'https://github.com/vechain/thor',
  },
  {
    slug: 'BTCGPU/BTCGPU',
    url: 'https://github.com/BTCGPU/BTCGPU',
  },
  {
    slug: 'qtumproject/qtum',
    url: 'https://github.com/qtumproject/qtum',
  },
  {
    slug: 'decred/dcrd',
    url: 'https://github.com/decred/dcrd',
  },
  {
    slug: 'decred/dcrwallet',
    url: 'https://github.com/decred/dcrwallet',
  },
  {
    slug: 'Synthetixio/synthetix',
    url: 'https://github.com/Synthetixio/synthetix',
  },
  {
    slug: 'icon-project/loopchain',
    url: 'https://github.com/icon-project/loopchain',
  },
  {
    slug: 'hashgraph/hedera-mirror-node',
    url: 'https://github.com/hashgraph/hedera-mirror-node',
  },
  {
    slug: 'hashgraph/hedera-sdk-java',
    url: 'https://github.com/hashgraph/hedera-sdk-java',
  },
  {
    slug: 'LiskHQ/lisk-sdk',
    url: 'https://github.com/LiskHQ/lisk-sdk',
  },
  {
    slug: 'algorand/go-algorand',
    url: 'https://github.com/algorand/go-algorand',
  },
  {
    slug: '0xProject/0x-monorepo',
    url: 'https://github.com/0xProject/0x-monorepo',
  },
  {
    slug: 'AugurProject/augur',
    url: 'https://github.com/AugurProject/augur',
  },
  {
    slug: 'wavesplatform/Waves',
    url: 'https://github.com/wavesplatform/Waves',
  },
  {
    slug: 'RavenProject/Ravencoin',
    url: 'https://github.com/RavenProject/Ravencoin',
  },
  {
    slug: 'eveybcd/BitcoinDiamond',
    url: 'https://github.com/eveybcd/BitcoinDiamond',
  },
  {
    slug: 'KyberNetwork/KyberSwap',
    url: 'https://github.com/KyberNetwork/KyberSwap',
  },
  {
    slug: 'KyberNetwork/smart-contracts',
    url: 'https://github.com/KyberNetwork/smart-contracts',
  },
];

// Maps
var periodMapData = {
  'last-week': {
    daily: fetchData['daily'].slice(-7),
  },
  'last-month': {
    daily: fetchData['daily'].slice(-30),
    weekly: fetchData['weekly'].slice(-4),
  },
  'last-year': {
    weekly: fetchData['weekly'],
    monthly: fetchData['monthly'],
  },
  'this-week': {
    daily: fetchData['daily'],
  },
  'this-month': {
    daily: fetchData['daily'],
    weekly: fetchData['weekly'],
  },
  'this-year': {
    weekly: fetchData['weekly'],
    monthly: fetchData['monthly'],
  },
  'prev-month': {
    daily: fetchData['daily'],
    weekly: fetchData['weekly'],
  },
  'prev-week': {
    daily: fetchData['daily'],
  },
};

var periodMapDataMultiple = {
  'last-week': {
    daily: [],
  },
  'last-month': {
    daily: [],
    weekly: [],
  },
  'last-year': {
    weekly: [],
    monthly: [],
  },
};

var categoryMapDataMultiple = {
  'last-week': {
    daily: [],
  },
  'last-month': {
    daily: [],
    weekly: [],
  },
  'last-year': {
    weekly: [],
    monthly: [],
  },
};

var showByMap = {
  'last-week': `<option value="daily">days</option>`,
  'last-month': `<option value="daily">days</option>`,
  'last-year': `<option value="weekly">weeks</option><option selected="selected" value="monthly">months</option>`,
  'this-week': `<option value="daily">days</option>`,
  'this-month': `<option value="daily">days</option>`,
};

var modeMap = {
  daily: 'Days',
  weekly: 'Weeks',
  monthly: 'Months',
};

var statsMap = {
  totalForCurrentPeriod: 0,
  totalForWholePeriod: 0,
  totalForPrevMonthPeriod: 0,
  totalForPrevWeekPeriod: 0,
  averageForCurrentPeriodDays: 0,
  averageForCurrentPeriodWeeks: 0,
  averageForCurrentPeriodMonths: 0,
  averageForWholePeriodDays: 0,
  averageForWholePeriodWeeks: 0,
  averageForWholePeriodMonths: 0,
  averageForPrevMonthPeriodDays: 0,
};

// Handlers
function handleSelectRepositoryChange() {
  var $this = $(this);
  var thisValue = $this.val();

  repository = thisValue;
  updateEndPoint();
  resetDataContainers();
}

function handleSelectPeriodChange() {
  var $this = $(this);
  var thisValue = $this.val();

  currentPeriod = thisValue;

  updateShowBySelectOption();
  $selectShowBy.trigger('change');

  updateChart();
  updateStats();
  updateTable();
}

function handleSelectPeriodMultipleChange() {
  var $this = $(this);
  var thisValue = $this.val();

  currentPeriod = thisValue;

  updateShowBySelectOption();
  $selectShowByMultiple.trigger('change');

  updateChartMultiple();
  updateTableMultiple();
}

function handleSelectShowByChange() {
  var $this = $(this);
  var thisValue = $this.val();

  currentMode = thisValue;

  updateChart();
  updateStats();
  updateTable();
}

function handleSelectShowByMultipleChange() {
  var $this = $(this);
  var thisValue = $this.val();

  currentMode = thisValue;

  updateChartMultiple();
  updateTableMultiple();
}

function handleButtonFetchDataClick() {
  var $this = $(this);

  if ($this.attr('disabled')) return;

  $fetchDataLoader.removeClass('d-none');
  $this.attr('disabled', 'disabled');

  $.ajax({
    url: endpointUrl,
    success: function (response) {
      $fetchDataLoader.addClass('d-none');
      $this.removeAttr('disabled');

      handleFetchResponse(response);
    },
    error: function (error) {
      $fetchDataLoader.addClass('d-none');
      $this.removeAttr('disabled');
      console.err(error);
    },
  });
}

function handleButtonFetchMultipleDataClick() {
  var $this = $(this);
  var $deffers = [];

  // Check for single selected option
  if ($selectRepository.val().length < 2) {
    return;
  }

  var urls = $selectRepository.val().map((item) => ({
    title: item,
    url: `https://api.github.com/repos/${item}/stats/commit_activity`,
  }));

  if ($this.attr('disabled')) return;

  $fetchDataLoader.removeClass('d-none');
  $this.attr('disabled', 'disabled');

  $deffers = urls.map((item) =>
    $.ajax({
      url: item.url,
    })
  );

  $.when
    .apply($, $deffers)
    .done(function () {
      let updatedPeriodMapData = {
        'last-week': {
          daily: [],
        },
        'last-month': {
          daily: [],
        },
        'last-year': {
          weekly: [],
          monthly: [],
        },
      };

      [...arguments].forEach((arg, index) => {
        var fetchDataMultiple = {};
        var rawData = arg[0];

        // Format data by mode
        fetchDataMultiple['daily'] = formatChartDataMultiple['daily'](rawData);
        fetchDataMultiple['weekly'] = formatChartDataMultiple['weekly'](
          rawData
        );
        fetchDataMultiple['monthly'] = formatChartDataMultiple['monthly'](
          rawData
        );

        // Push into updated
        updatedPeriodMapData['last-week']['daily'].push({
          seriesname: urls[index].title,
          data: fetchDataMultiple['daily'].slice(-7),
        });

        updatedPeriodMapData['last-month']['daily'].push({
          seriesname: urls[index].title,
          data: fetchDataMultiple['daily'].slice(-30),
        });

        updatedPeriodMapData['last-year']['weekly'].push({
          seriesname: urls[index].title,
          data: fetchDataMultiple['weekly'],
        });

        updatedPeriodMapData['last-year']['monthly'].push({
          seriesname: urls[index].title,
          data: fetchDataMultiple['monthly'],
        });
      });

      $fetchDataLoader.addClass('d-none');
      $this.removeAttr('disabled');

      // Update periodMapDataMultiple - to be moved to another function and refactored
      periodMapDataMultiple['last-week']['daily'] = [
        ...updatedPeriodMapData['last-week']['daily'],
      ];
      periodMapDataMultiple['last-month']['daily'] = [
        ...updatedPeriodMapData['last-month']['daily'],
      ];
      periodMapDataMultiple['last-year']['weekly'] = [
        ...updatedPeriodMapData['last-year']['weekly'],
      ];
      periodMapDataMultiple['last-year']['monthly'] = [
        ...updatedPeriodMapData['last-year']['monthly'],
      ];

      // Update categoryMapDataMultiple - to be moved to another function and refactored
      categoryMapDataMultiple['last-week']['daily'] = periodMapDataMultiple[
        'last-week'
      ]['daily'][0].data.map((el) => ({
        label: el.label,
      }));

      categoryMapDataMultiple['last-month']['daily'] = periodMapDataMultiple[
        'last-month'
      ]['daily'][0].data.map((el) => ({
        label: el.label,
      }));

      categoryMapDataMultiple['last-year']['weekly'] = periodMapDataMultiple[
        'last-year'
      ]['weekly'][0].data.map((el) => ({
        label: el.label,
      }));

      categoryMapDataMultiple['last-year']['monthly'] = periodMapDataMultiple[
        'last-year'
      ]['monthly'][0].data.map((el) => ({
        label: el.label,
      }));

      updateChartMultiple();

      updateTableMultiple();
    })
    .fail(function (err) {
      console.log(err);

      $fetchDataLoader.addClass('d-none');
      $this.removeAttr('disabled');
    });
}

function handleFetchResponse(response) {
  // Format daily data
  formatChartData.daily(response);
  formatTableData.daily(response);

  // Format weekly data
  formatChartData.weekly(response);
  formatTableData.weekly(response);

  // Format monthly data
  formatChartData.monthly(response);
  formatTableData.monthly(response);

  updatePeriodData();

  updateChart();

  updateStats();

  updateTable();
}

function handleInputDatepickerSelect(formattedDate, date, inst) {
  selectedDate = dayjs(date).toISOString();

  updateEndPoint();
  resetDataContainers();
}

// Helpers
var helpers = {
  formatDate: function (rawDateMiliseconds) {
    return dayjs(rawDateMiliseconds * 1000).format('DD MMM YYYY');
  },
  formatMonth: function (rawDateMiliseconds) {
    return dayjs(rawDateMiliseconds * 1000).format('MMM YYYY');
  },
};

var formatChartData = {
  daily: function (rawData) {
    // Get daily data
    var dailyData = [];
    var dailyDataThisMonth = [];
    var dailyDataPrevMonth = [];
    var dailyDataThisWeek = [];
    var dailyDataPrevWeek = [];

    rawData.forEach((el) => {
      var weekData = el.days;
      var lastWeek = rawData[rawData.length - 1].week;
      var prevLastWeek = lastWeek - 604800;

      weekData.forEach((elInner, index) => {
        var weekDay = el.week * 1000 + index * 86400000;

        if (weekDay > Date.now()) {
          return;
        }

        dailyData.push({
          label: dayjs(weekDay).format('DD MMM YYYY'),
          value: elInner,
        });

        // Check for 1st day of the current month
        var currentDate = new Date(),
          y = currentDate.getFullYear(),
          m = currentDate.getMonth(),
          lm = m - 1; // TODO - Make check if lm > 0

        var firstDayOfThisMonth = new Date(y, m, 1);
        var firstDayOfLastMonth = new Date(y, lm, 1);
        var today = new Date();

        // Get data for last week
        if (el.week == lastWeek && weekDay <= today) {
          dailyDataThisWeek.push({
            label: dayjs(weekDay).format('DD MMM YYYY'),
            value: elInner,
          });
        }

        // Get data for prev week
        if (el.week == prevLastWeek && el.week <= lastWeek) {
          dailyDataPrevWeek.push({
            label: dayjs(weekDay).format('DD MMM YYYY'),
            value: elInner,
          });
        }

        // Get data for this month
        if (weekDay > firstDayOfThisMonth) {
          dailyDataThisMonth.push({
            label: dayjs(weekDay).format('DD MMM YYYY'),
            value: elInner,
          });
        }

        // Get data for prev month
        if (weekDay > firstDayOfLastMonth && weekDay < firstDayOfThisMonth) {
          dailyDataPrevMonth.push({
            label: dayjs(weekDay).format('DD MMM YYYY'),
            value: elInner,
          });
        }
      });
    });

    fetchData.daily = [...dailyData];

    // To be refactored
    periodMapData['this-week'].daily = [...dailyDataThisWeek];
    periodMapData['this-month'].daily = [...dailyDataThisMonth];
    periodMapData['prev-week'].daily = [...dailyDataPrevWeek];
    periodMapData['prev-month'].daily = [...dailyDataPrevMonth];
  },
  weekly: function (rawData) {
    fetchData.weekly = rawData.map((el) => ({
      label: helpers.formatDate(el.week),
      value: el.total,
    }));
  },
  monthly: function (rawData) {
    var monthlyData = [];
    var groupedByMonth = {};

    rawData.forEach((el) => {
      var commitMonth = helpers.formatMonth(el.week);
      if (groupedByMonth[commitMonth]) {
        groupedByMonth[commitMonth] += el.total;
      } else {
        groupedByMonth[commitMonth] = el.total;
      }
    });

    monthlyData = Object.keys(groupedByMonth).map((key) => ({
      label: key,
      value: groupedByMonth[key],
    }));

    fetchData.monthly = [...monthlyData];
  },
};

var formatChartDataMultiple = {
  daily: function (rawData) {
    // Get daily data
    var dailyData = [];

    if (rawData.length == 0) {
      return dailyData;
    }

    rawData.forEach((el) => {
      var weekData = el.days;

      weekData.forEach((elInner, index) => {
        var weekDay = el.week * 1000 + index * 86400000;

        if (weekDay > Date.now()) {
          return;
        }

        dailyData.push({
          label: dayjs(weekDay).format('DD MMM YYYY'),
          value: elInner,
        });
      });
    });

    return dailyData;
  },
  weekly: function (rawData) {
    if (rawData.length == 0) {
      return [];
    }

    var weeklyData = rawData.map((el) => ({
      label: helpers.formatDate(el.week),
      value: el.total,
    }));

    return weeklyData;
  },
  monthly: function (rawData) {
    if (rawData.length == 0) {
      return [];
    }

    var monthlyData = [];
    var groupedByMonth = {};

    rawData.forEach((el) => {
      var commitMonth = helpers.formatMonth(el.week);
      if (groupedByMonth[commitMonth]) {
        groupedByMonth[commitMonth] += el.total;
      } else {
        groupedByMonth[commitMonth] = el.total;
      }
    });

    monthlyData = Object.keys(groupedByMonth).map((key) => ({
      label: key,
      value: groupedByMonth[key],
    }));

    return monthlyData;
  },
};

var formatTableData = {
  daily: function (rawData) {
    tableData.daily.tableHeaderHTML = ``;
    tableData.daily.tableBodyHTML = ``;
  },
  weekly: function (rawData) {
    tableData.weekly.tableHeaderData = [
      'Week',
      'Monday',
      'Thuesday',
      'Wednesday',
      'Thursday',
      'Firday',
      'Saturday',
      'Sunday',
      'Total',
    ];

    tableData.weekly.tableHeaderHTML = tableData.weekly.tableHeaderData
      .map((el) => `<th>${el}</th>`)
      .join('');

    tableData.weekly.tableBodyData = rawData
      .map((el) => ({
        week: helpers.formatDate(el.week),
        monday: el.days[1],
        thuesday: el.days[2],
        wednesday: el.days[3],
        thursday: el.days[4],
        firday: el.days[5],
        saturday: el.days[6],
        sunday: el.days[0],
        total: el.total,
      }))
      .reverse();

    tableData.weekly.tableBodyHTML = tableData.weekly.tableBodyData
      .map((el, index) => {
        var cellClass = '';
        var totalTooltip = '';

        var prevElement = tableData.weekly.tableBodyData[index + 1];

        if (prevElement) {
          var hasIncrease =
            el.total >
            prevElement.total * (percentage / 100) + prevElement.total;
          var hasDecrease =
            el.total <
            prevElement.total - prevElement.total * (percentage / 100);

          if (hasIncrease) {
            cellClass = 'text-success';
            totalTooltip = `data-toggle="tooltip" data-placement="top" title="More than ${percentage}% increase"`;
          }

          if (hasDecrease) {
            cellClass = 'text-danger';
            totalTooltip = `data-toggle="tooltip" data-placement="top" title="More than ${percentage}% decrease"`;
          }
        }

        return `
          <tr>
            <td class="cell-numeric">${el.week}</td>
            <td class="text-right cell-numeric">${el.monday}</td>
            <td class="text-right cell-numeric">${el.thuesday}</td>
            <td class="text-right cell-numeric">${el.wednesday}</td>
            <td class="text-right cell-numeric">${el.thursday}</td>
            <td class="text-right cell-numeric">${el.firday}</td>
            <td class="text-right cell-numeric">${el.saturday}</td>
            <td class="text-right cell-numeric">${el.sunday}</td>
            <td class="text-right cell-numeric text-bold ${cellClass}">
              <span ${totalTooltip}>
                ${el.total}
              </span>
            </td>
          </tr>
        `;
      })
      .join('');
  },
  monthly: function (rawData) {
    tableData.monthly.tableHeaderData = ['Month', 'Total'];

    tableData.monthly.tableHeaderHTML = tableData.monthly.tableHeaderData
      .map((el) => `<th>${el}</th>`)
      .join('');

    var monthlyData = [];
    var groupedByMonth = {};

    rawData.forEach((el) => {
      var commitMonth = helpers.formatMonth(el.week);
      if (groupedByMonth[commitMonth]) {
        groupedByMonth[commitMonth] += el.total;
      } else {
        groupedByMonth[commitMonth] = el.total;
      }
    });

    monthlyData = Object.keys(groupedByMonth).map((key) => ({
      label: key,
      value: groupedByMonth[key],
    }));

    tableData.monthly.tableBodyData = monthlyData
      .map((el) => ({
        month: el.label,
        total: el.value,
      }))
      .reverse();

    tableData.monthly.tableBodyHTML = tableData.monthly.tableBodyData
      .map((el, index) => {
        var cellClass = '';
        var totalTooltip = '';

        var prevElement = tableData.monthly.tableBodyData[index + 1];

        if (prevElement) {
          var hasIncrease =
            el.total >
            prevElement.total * (percentage / 100) + prevElement.total;
          var hasDecrease =
            el.total <
            prevElement.total - prevElement.total * (percentage / 100);

          if (hasIncrease) {
            cellClass = 'text-success';
            totalTooltip = `data-toggle="tooltip" data-placement="top" title="More than ${percentage}% increase"`;
          }

          if (hasDecrease) {
            cellClass = 'text-danger';
            totalTooltip = `data-toggle="tooltip" data-placement="top" title="More than ${percentage}% decrease"`;
          }
        }

        return `
          <tr>
            <td class="cell-numeric">${el.month}</td>
            <td class="text-right cell-numeric text-bold ${cellClass}">
              <span ${totalTooltip}>
                ${el.total}
              </span>
            </td>
          </tr>
        `;
      })
      .join('');
  },
};

// Functions
function updateEndPoint() {
  endpointUrl = `${endpointBaseUrl}${repository}${params}`;
}

function updatePeriodData() {
  periodMapData = {
    ...periodMapData,
    'last-week': {
      daily: fetchData['daily'].slice(-7),
    },
    'last-month': {
      daily: fetchData['daily'].slice(-30),
      weekly: fetchData['weekly'].slice(-4),
    },
    'last-year': {
      weekly: fetchData['weekly'],
      monthly: fetchData['monthly'],
    },
  };
}

function updateShowBySelectOption() {
  $selectShowBy.html(showByMap[currentPeriod]);
  $selectShowByMultiple.html(showByMap[currentPeriod]);
}

function updateChart() {
  chartConfigs.dataSource.data = periodMapData[currentPeriod][currentMode];
  chartConfigs.dataSource.chart.caption = 'Commits Activity';
  chartConfigs.dataSource.chart.subCaption = repository;
  chartConfigs.dataSource.chart.xAxisName = modeMap[currentMode];

  // To be refactored
  if (currentMode == 'daily') {
    chartConfigs.dataSource.trendlines[0].line[0].startValue =
      statsMap.averageForCurrentPeriodDays;
  }

  if (currentMode == 'weekly') {
    chartConfigs.dataSource.trendlines[0].line[0].startValue =
      statsMap.averageForCurrentPeriodWeeks;
  }

  if (currentMode == 'monthly') {
    chartConfigs.dataSource.trendlines[0].line[0].startValue =
      statsMap.averageForCurrentPeriodMonths;
  }

  $chartContainer.insertFusionCharts(chartConfigs);
}

function updateChartMultiple() {
  // Update chart config multiple
  chartConfigsMultiple.dataSource.dataset = [
    ...periodMapDataMultiple[currentPeriod][currentMode],
  ];
  chartConfigsMultiple.dataSource.categories[0].category = [
    ...categoryMapDataMultiple[currentPeriod][currentMode],
  ];

  $chartContainer.insertFusionCharts(chartConfigsMultiple);
}

function updateStats() {
  // Get total commits for whole period (52 weeks)
  statsMap.totalForWholePeriod = fetchData.weekly.reduce(
    (total, item) => total + item.value,
    0
  );

  // Get total commits for current period
  statsMap.totalForCurrentPeriod = periodMapData[currentPeriod][
    currentMode
  ].reduce((total, item) => total + item.value, 0);

  // Get total commits for prevoius week
  statsMap.totalForPrevWeekPeriod = periodMapData['prev-week']['daily'].reduce(
    (total, item) => total + item.value,
    0
  );

  // Get total commits for prevoius month
  statsMap.totalForPrevMonthPeriod = periodMapData['prev-month'][
    'daily'
  ].reduce((total, item) => total + item.value, 0);

  // Get average for whole period by day
  statsMap.averageForWholePeriodDays =
    statsMap.totalForWholePeriod / fetchData.daily.length;

  // Get average for whole period by week
  statsMap.averageForWholePeriodWeeks =
    statsMap.totalForWholePeriod / fetchData.weekly.length;

  // Get average for whole period by month
  statsMap.averageForWholePeriodMonths =
    statsMap.totalForWholePeriod / fetchData.monthly.length;

  // Get average for whole period by day
  statsMap.averageForCurrentPeriodDays = periodMapData[currentPeriod]['daily']
    ? statsMap.totalForCurrentPeriod /
      periodMapData[currentPeriod]['daily'].length
    : 0;

  // Get average for Current period by week
  statsMap.averageForCurrentPeriodWeeks =
    periodMapData[currentPeriod]['weekly'] &&
    periodMapData[currentPeriod]['weekly'].length > 0
      ? statsMap.totalForCurrentPeriod /
        periodMapData[currentPeriod]['weekly'].length
      : 0;

  // Get average for Current period by month
  statsMap.averageForCurrentPeriodMonths = periodMapData[currentPeriod][
    'monthly'
  ]
    ? statsMap.totalForCurrentPeriod /
      periodMapData[currentPeriod]['monthly'].length
    : 0;

  // Get average for Prev month period by day
  statsMap.averageForPrevMonthPeriodDays = periodMapData[currentPeriod]['daily']
    ? statsMap.totalForPrevMonthPeriod /
      periodMapData['prev-month']['daily'].length
    : 0;

  // Additional stats
  var perDiffMonth = 0;
  var perDiffWeek = 0;
  var perDiffDay = 0;
  var perDiffIndicator = ``;

  if (currentPeriod == 'last-month') {
    perDiffMonth =
      1 - statsMap.totalForCurrentPeriod / statsMap.averageForWholePeriodMonths;
  }

  if (currentPeriod == 'last-week') {
    perDiffWeek =
      1 - statsMap.totalForCurrentPeriod / statsMap.averageForWholePeriodWeeks;
  }

  if (currentPeriod == 'this-week') {
    perDiffWeek =
      1 - statsMap.totalForCurrentPeriod / statsMap.totalForPrevWeekPeriod;
  }

  if (currentPeriod == 'this-month') {
    perDiffMonth =
      1 - statsMap.totalForCurrentPeriod / statsMap.totalForPrevMonthPeriod;
  }

  if (perDiffMonth > 0) {
    perDiffIndicator = `<i data-toggle="tooltip" data-placement="top" title="${numeral(
      perDiffMonth
    ).format(
      '0.00%'
    )} decrease" class="fas fa-long-arrow-alt-down text-danger"></i>`;
  } else if (perDiffMonth < 0) {
    perDiffIndicator = `<i data-toggle="tooltip" data-placement="top" title="${numeral(
      Math.abs(perDiffMonth)
    ).format(
      '0.00%'
    )} increase"class="fas fa-long-arrow-alt-up text-success"></i>`;
  }

  if (perDiffWeek > 0) {
    perDiffIndicator = `<i data-toggle="tooltip" data-placement="top" title="${numeral(
      perDiffWeek
    ).format(
      '0.00%'
    )} decrease" class="fas fa-long-arrow-alt-down text-danger"></i>`;
  } else if (perDiffWeek < 0) {
    perDiffIndicator = `<i data-toggle="tooltip" data-placement="top" title="${numeral(
      Math.abs(perDiffWeek)
    ).format(
      '0.00%'
    )} increase"class="fas fa-long-arrow-alt-up text-success"></i>`;
  }

  if (perDiffDay > 0) {
    perDiffIndicator = `<i data-toggle="tooltip" data-placement="top" title="${numeral(
      perDiffDay
    ).format(
      '0.00%'
    )} decrease" class="fas fa-long-arrow-alt-down text-danger"></i>`;
  } else if (perDiffDay < 0) {
    perDiffIndicator = `<i data-toggle="tooltip" data-placement="top" title="${numeral(
      Math.abs(perDiffDay)
    ).format(
      '0.00%'
    )} increase"class="fas fa-long-arrow-alt-up text-success"></i>`;
  }

  $statsContainer.html(`
    <div class="row mb-4 mb-lg-6">
      ${
        statsMap.totalForCurrentPeriod != statsMap.totalForWholePeriod
          ? `<div class="col-md-6 mb-4 mb-md-0">
        <div class="card bg-snow p-4">
          <h2 class="text-headline mb-4">Stats for current period</h2>
          <div class="d-flex justify-content-between">
            <p class="text-title">Total commits:</p>
            <div>
              <span>${perDiffIndicator}</span>
              <span class="text-title text-bold cell-numeric ml-1">${numeral(
                statsMap.totalForCurrentPeriod
              ).format('0,0')}</span>
            </div>
          </div>
          <hr class="my-4">
          <div class="">
            <p class="text-title mb-3">Average commits</p>
            <table class="table table-sm">
              ${
                statsMap.averageForCurrentPeriodDays != 0
                  ? `<tr>
                <td class="text-slate">Per day</td>
                <td class="text-right text-bold cell-numeric">${numeral(
                  statsMap.averageForCurrentPeriodDays
                ).format('0,0.00')}</td>
              </tr>`
                  : ''
              }
              ${
                statsMap.averageForCurrentPeriodWeeks != 0
                  ? `<tr>
                <td class="text-slate">Per week</td>
                <td class="text-right text-bold cell-numeric">${numeral(
                  statsMap.averageForCurrentPeriodWeeks
                ).format('0,0.00')}</td>
              </tr>`
                  : ''
              }
              ${
                statsMap.averageForCurrentPeriodMonths != 0
                  ? `<tr>
                <td class="text-slate">Per month</td>
                <td class="text-right text-bold cell-numeric">${numeral(
                  statsMap.averageForCurrentPeriodMonths
                ).format('0,0.00')}</td>
              </tr>`
                  : ''
              }
            </table>
          </div>
        </div>
      </div>`
          : ''
      }

      <div class="${
        statsMap.totalForCurrentPeriod != statsMap.totalForWholePeriod
          ? 'col-md-6'
          : 'col-12'
      }">
        <div class="card bg-snow p-4">
          <h2 class="text-headline mb-4">Stats for whole period (52 weeks)</h2>
          <div class="d-flex justify-content-between">
            <p class="text-title">Total commits</p>
            <span class="text-title text-bold cell-numeric">${numeral(
              statsMap.totalForWholePeriod
            ).format('0,0')}</span>
          </div>
          <hr class="my-4">
          <div class="">
            <p class="text-title mb-3">Average commits</p>
            <table class="table table-sm">
              <tr>
                <td class="text-slate">Per day</td>
                <td class="text-right text-bold cell-numeric">${numeral(
                  statsMap.averageForWholePeriodDays
                ).format('0,0.00')}</td>
              </tr>
              <tr>
                <td class="text-slate">Per week</td>
                <td class="text-right text-bold cell-numeric">${numeral(
                  statsMap.averageForWholePeriodWeeks
                ).format('0,0.00')}</td>
              </tr>
              <tr>
                <td class="text-slate">Per month</td>
                <td class="text-right text-bold cell-numeric">${numeral(
                  statsMap.averageForWholePeriodMonths
                ).format('0,0.00')}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  `);
  $statsContainer.show();
}

function updateTable() {
  var tableRows = tableData[currentMode].tableBodyHTML;
  var tableHeader = tableData[currentMode].tableHeaderHTML;

  var tableCommits = '';

  if (tableRows == '' || tableHeader == '') {
    tableCommits = `<p class="text-center">Comming soon...</p>`;
  } else {
    tableCommits = `
    <table class="table table-sm table-bordered table-hover">
      <tr>
        ${tableHeader}
      </tr>
      ${tableRows}
    </table>`;
  }

  $tableContainer.html(tableCommits);

  $('[data-toggle="tooltip"]').tooltip();
}

function updateTableMultiple() {
  formatTableDataMultiple();

  var tableRows = tableDataMultiple[currentPeriod].tableBodyHTML;
  var tableHeader = tableDataMultiple[currentPeriod].tableHeaderHTML;

  var tableCommits = '';

  if (tableRows == '' || tableHeader == '') {
    tableCommits = `<p class="text-center">Comming soon...</p>`;
  } else {
    tableCommits = `
    <table class="table table-sm table-bordered table-hover">
      <tr>
        ${tableHeader}
      </tr>
      ${tableRows}
    </table>`;
  }

  $tableContainer.html(tableCommits);

  $('[data-toggle="tooltip"]').tooltip();
}

function resetDataContainers() {
  $chartContainer.html('');
  $tableContainer.html('');
  $statsContainer.hide();
}

function formatTableDataMultiple() {
  var tableData = periodMapDataMultiple[currentPeriod][currentMode]
    .map((el) => ({
      label: el.seriesname,
      value: el.data.reduce((total, innerEl) => total + innerEl.value, 0),
    }))
    .sort((a, b) => b.value - a.value);

  var tableDataSorted = tableData
    .map(
      (el) =>
        `<tr><td>${el.label}</td><td class="text-right cell-numeric">${numeral(
          el.value
        ).format('0,0')}</td></tr>`
    )
    .join('');

  tableDataMultiple[currentPeriod].tableHeaderHTML =
    '<th>Repository</th><th class="text-right">Total</th>';
  tableDataMultiple[currentPeriod].tableBodyHTML = tableDataSorted;
}

function updateRepositorySelectContent() {
  var allRepos = [...reposList, ...localStore.repos];
  var reposOptions = allRepos
    .map(
      (item, index) =>
        `<option ${index == 0 ? 'selected="selected"' : ''} value="${
          item.slug
        }">${item.url}</option>`
    )
    .join('');

  $selectRepository.html(reposOptions);

  repository = $selectRepository.val();

  updateEndPoint();
}

// Events
$(document).ready(function () {
  // $inputDatepicker.datepicker(datepickerConfig);

  // Update repository select
  updateRepositorySelectContent();

  $selectRepository.on('change', handleSelectRepositoryChange);
  $selectPeriod.on('change', handleSelectPeriodChange);
  $selectPeriodMultiple.on('change', handleSelectPeriodMultipleChange);
  $selectShowBy.on('change', handleSelectShowByChange);
  $selectShowByMultiple.on('change', handleSelectShowByMultipleChange);
  $buttonFetchData.on('click', handleButtonFetchDataClick);
  $buttonFetchMultipleData.on('click', handleButtonFetchMultipleDataClick);
});
